import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MasterService } from '../../../services/master.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ToastrManager } from 'ng6-toastr-notifications';
import { PopupManager } from 'ng6-popup-boxes';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-candidate-details',
  templateUrl: './candidate-details.component.html',
  styleUrls: ['./candidate-details.component.scss']
})

export class CandidateDetailsComponent implements OnInit {
  view: any = 'evaluation';
  valForm: FormGroup;
  issumbit: boolean = true;
  college: any;
  college_name: any;
  degree: any;
  OTP_Form: FormGroup;
  OTP_email_Form: FormGroup;
  SubmitForm: FormGroup;
  otp_from_api: number;
  OTP_verified: boolean = false;
  otp_from_email: number;
  OTP_email_verified: boolean = false;
  isverify: boolean = false;
  previewUrl_flight: any;
  previewUrl_id: any;
  previewUrl_resumee: any;
  previewUrl_aadhaarr: any;
  branch_name: any;
  isLoading: boolean = false;
  isLoadingg: boolean = false;
 isUploading_flight:boolean = false;
isUploading_id:boolean = false;
isUploading_resume:boolean = false;
isUploading_aadhaar:boolean = false;

 ismobileverify: boolean = false;
  showEmailSuccessAnimation: boolean = false;
  otpInputs: string[] = ["", "", "", ""];
  otpInput: string[] = ["", "", "", ""];
  showEmailAnimation: boolean = false;
  year_of_passed_out = [
    2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009,
    2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019,
    2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029,
    2030
  ];
  @ViewChild('file') file: ElementRef;
  @ViewChild('id_image') id_image: ElementRef;
  @ViewChild('resume') resume: ElementRef;
  @ViewChild('aadhaar') aadhaar: ElementRef;
  @ViewChild('OTP_popup') OTP_popup: any;
  @ViewChild('OTP_email_popup') OTP_email_popup: any;
  @ViewChild('email') emailInput: ElementRef;
  @ViewChild('mobile') mobileInput: ElementRef;
  @ViewChild('Name') candidateNameInput!: ElementRef<HTMLInputElement>;
  @ViewChild('submit') submit: any;
  @ViewChild('otp0') otp0: ElementRef;
  @ViewChild('otp1') otp1: ElementRef;
  @ViewChild('otp2') otp2: ElementRef;
  @ViewChild('otp3') otp3: ElementRef;
  @ViewChild('otpp0') otpp0: ElementRef;
  @ViewChild('otpp1') otpp1: ElementRef;
  @ViewChild('otpp2') otpp2: ElementRef;
  @ViewChild('otpp3') otpp3: ElementRef;
  get_table: any;
  college_namee: any;
  selectedCollegeId: any = null;

  onCollegeSelect(event: any) {
    if (event && event.item) {
      this.selectedCollegeId = event.item.college_id;
    }
  }
 
  constructor(fb: FormBuilder, public service: MasterService, private datep: DatePipe, public toastr: ToastrManager,
     public popupManager: PopupManager, private sanitizer: DomSanitizer) {
    this.valForm = fb.group({
      'candidate_id': '',
      'candidate_name': ['', Validators.required],
      'email': ['', [Validators.required, Validators.email]],
      'mobile_no': ['', [Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$'), Validators.required,]],
      'degree': ['', Validators.required],
      'department': ['', Validators.required],
      'year_of_passout': ['', Validators.required],
      'candidate_profile': '',
      'gender': ['', Validators.required],
      'candidate_clg': ['', Validators.required],
      'college_id': '',
      'resume': '',
      'aadhaar_card': '',
       'branch': ['', Validators.required],
       'reg_no': ['', Validators.required],
       
    });
    this.OTP_Form = fb.group({
      otp: ['', [Validators.required, Validators.pattern(/^\d{4}$/)]]
    });
    this.OTP_email_Form = fb.group({
      otpp: ['', [Validators.required, Validators.pattern(/^\d{4}$/)]]
    });
  }
  ngOnInit() {
   this.get_m_degree();
    this.get_m_college_list();
    this.get_m_branch()
  }
   get_m_degree() {
    this.service.get_m_degree().subscribe(data => {
      this.degree = data['data'];
    })
  }
 get_m_college_list() {
    this.service.get_m_college_list(-1).subscribe(data => {
      this.college_namee = data['data'];
    })
  }
  get_m_branch() {
    this.service.get_m_branch().subscribe(data => {
      this.branch_name = data['data'];
    })
  }
   insertedCandidateId: string = '';

  get_m_candidate_details(afterInsert: boolean = false) {
    this.service.get_m_candidate_details(-1).subscribe(data => {
      this.get_table = data['data'];

      if (afterInsert && data['data'] && data['data'].length > 0) {
        this.insertedCandidateId = data['data'][0].candidate_id;
      }
    });
  }

  insert_m_candidate_details() {
    this.issumbit = false;
    this.valForm.value.candidate_profile = this.previewUrl_flight;
    this.valForm.value.college_id = this.previewUrl_id;
    this.valForm.value.resume = this.previewUrl_resumee;
    this.valForm.value.aadhaar_card = this.previewUrl_aadhaarr;
    if (this.valForm.value.email && this.valForm.controls['email'].hasError('email')) {
      this.toastr.warningToastr('Enter valid Email')
      this.issumbit = true;
    }
    else if (this.valForm.value.candidate_name == '' || this.valForm.value.candidate_name == null || this.valForm.value.candidate_name == undefined) {
      this.toastr.warningToastr('Enter Candidate Name')
      this.issumbit = true;
    }
    else if (this.valForm.value.email == '' || this.valForm.value.email == null || this.valForm.value.email == undefined) {
      this.toastr.warningToastr('Enter Email Id')
      this.issumbit = true;
    }
    else if (this.valForm.value.mobile_no == '' || this.valForm.value.mobile_no == null || this.valForm.value.mobile_no == undefined) {
      this.toastr.warningToastr('Enter Candidate Contact No')
      this.issumbit = true;
    }
    else if (this.valForm.value.degree == '' || this.valForm.value.degree == null || this.valForm.value.degree == undefined) {
      this.toastr.warningToastr('Enter Degree')
      this.issumbit = true;
    }
    else if (this.valForm.value.candidate_clg == '' || this.valForm.value.candidate_clg == null || this.valForm.value.candidate_clg == undefined) {
      this.toastr.warningToastr('Select College')
      this.issumbit = true;
    }
    else if (this.valForm.value.department == '' || this.valForm.value.department == null || this.valForm.value.department == undefined) {
      this.toastr.warningToastr('Enter Department')
      this.issumbit = true;
    }
    else if (this.valForm.value.year_of_passout == '' || this.valForm.value.year_of_passout == null || this.valForm.value.year_of_passout == undefined) {
      this.toastr.warningToastr('Select Year Of Passed Out')
      this.issumbit = true;
    }
    // else if (this.OTP_verified == false) {
    //   this.toastr.warningToastr('Mobile Number Not Verified')
    //     this.issumbit=true;
    // }
    else if (this.OTP_email_verified == false) {
      this.toastr.warningToastr('Email Not Verified')
        this.issumbit=true;
    }
    else if (this.previewUrl_flight == '' || this.previewUrl_flight == null) {
      this.toastr.warningToastr('Please Upload Profile')
      this.issumbit = true;
    }
    else if (this.previewUrl_id == '' || this.previewUrl_id == null) {
      this.toastr.warningToastr('Please Upload Candidate Id')
      this.issumbit = true;
    }
    else if (this.previewUrl_resumee == '' || this.previewUrl_resumee == null) {
      this.toastr.warningToastr('Please Upload resume')
      this.issumbit = true;
    }
    else if (this.previewUrl_aadhaarr == '' || this.previewUrl_aadhaarr == null) {
      this.toastr.warningToastr('Please Upload Aadharcard')
      this.issumbit = true;
    }
    else {
      const selectedCollege = this.college_namee && this.college_namee.find(
        (item: any) => item.college_name === this.valForm.value.candidate_clg || item.college_id == this.valForm.value.candidate_clg
      );
      const collegeIdToSend = selectedCollege ? selectedCollege.college_id : (this.selectedCollegeId || this.valForm.value.candidate_clg);

      const payload = {
        ...this.valForm.value,
        candidate_clg: collegeIdToSend
      };

      this.service.insert_m_candidate_details(payload).subscribe(data => {
        if (data['code'] == '200') {
          this.submit.show();
          this.toastr.successToastr('saved successfully');
            this.get_m_candidate_details(true);
          this.issumbit = true;
          }
        else {
          this.submit.hide();
          this.toastr.errorToastr('Failed', data['data']);
           this.issumbit = true;
        }
      })
    }
  }
onFileSelectedUnified(event: any, type: string) {
  

  const file = event.target.files[0];
  if (!file) return;
  switch (type) {
    case 'flight':
      this.isUploading_flight = true;
      break;
    case 'id':
      this.isUploading_id = true;
      break;
    case 'resume':
      this.isUploading_resume = true;
      break;
    case 'aadhaar':
      this.isUploading_aadhaar = true;
      break;
  }

  this.service.uploadFilee(file).subscribe({
    next: (res) => {
      switch (type) {
        case 'flight':
          this.previewUrl_flight = res.url;
              this.isUploading_flight = false;
          break;  
        case 'id':
          this.previewUrl_id = res.url;
             this.isUploading_id = false;
          break;
        case 'resume':
          this.previewUrl_resumee = res.url;
               this.isUploading_resume = false;
          break;
        case 'aadhaar':
          this.previewUrl_aadhaarr = res.url;
              this.isUploading_aadhaar = false;
          break;
      }
    },
    error: (err) => {
      console.error('Upload error for', type, err);
            this.isUploading_flight = false;
      this.isUploading_id = false;
      this.isUploading_resume = false;
      this.isUploading_aadhaar = false;
    }
  });
}
 limit_ten(event) {
    const val = (event.target as HTMLInputElement).value;
    if (val.length >= 10) {
      event.preventDefault();
    }
  }
 mobile_validation_api(ph_no) {
    if (this.valForm.value.mobile_no == '' || this.valForm.value.mobile_no == null || this.valForm.value.mobile_no == undefined) {
      this.toastr.warningToastr('Please fill mobile_no')
    }
    else {
      this.otp_from_api = 0;
      this.ismobileverify = true;
      this.isLoadingg = true;
      const ph_no_1 = {
        'to': '+91' + ph_no
      }
      this.service.mobile_validation_api(ph_no_1).subscribe(data => {
        if (data['code'] == '200') {
          this.OTP_popup.show()
          const otp = data['data'];
          const otp_num = Number(otp) - 101;
          this.otp_from_api = otp_num;
          this.ismobileverify = false;
          this.isLoadingg = false;
        }
        else {
          this.toastr.errorToastr('OTP Not Generated')
          this.ismobileverify = false;
          this.isLoadingg = false;
        }
      })
    }
  }

  email_validation_api() {
    if (this.valForm.value.email == '' || this.valForm.value.email == null || this.valForm.value.email == undefined) {
      this.toastr.warningToastr('Please fill Mail')
    }
    else {
      this.otp_from_email = 0;
      this.isLoading = true;
      this.isverify = true;
      this.service.request_send_log_email(this.valForm.value.email).subscribe(data => {
        if (data['code'] == '200') {
          this.OTP_email_popup.show()
          const otp = data['data'];
          const otp_num = Number(otp) - 101;
          this.otp_from_email = otp_num;
          this.isLoading = false;
          this.isverify = false;
        }
        else {
          this.toastr.errorToastr('OTP Not Generated')
          this.isLoading = false;
          this.isverify = false;
        }
      })
    }
  }

  verify_otp(otp) {
    this.OTP_verified = false;
    if (this.otp_from_api == otp) {
      this.toastr.successToastr('OTP Verified Successfully');
      this.OTP_verified = true;
      this.showEmailSuccessAnimation = true;
      setTimeout(() => {
        this.OTP_popup.hide()
        this.showEmailSuccessAnimation = false;
      }, 2000);
    }
    else {
      this.toastr.errorToastr('Invalid OTP', 'Please Enter Valid OTP')
    }
  }

  verify_email(otpp) {
    this.OTP_email_verified = false;
    if (this.otp_from_email == otpp) {
      this.toastr.successToastr('OTP Verified Successfully');
      this.OTP_email_verified = true;
      this.showEmailAnimation = true;
      setTimeout(() => {
        this.OTP_email_popup.hide()
        this.showEmailSuccessAnimation = false;
      }, 2000);
    }
    else {
      this.toastr.errorToastr('Invalid OTP', 'Please Enter Valid OTP')
    }
  }

  steps = ['evaluation', 'review', 'resumereview', 'aadharreview'];
  currentStep = 0;

  get currentView() {
    return this.steps[this.currentStep];
  }

 changeStep(direction: 'next' | 'prev') {
  if (direction === 'next' && this.currentStep < this.steps.length - 1) {
    this.currentStep++;
  } else if (direction === 'prev' && this.currentStep > 0) {
    this.currentStep--;
  }
}

  triggerValidationShake() {
    Object.keys(this.valForm.controls).forEach(field => {
      const control = this.valForm.get(field);
      if (control && control.invalid) {
        const element = document.querySelector(`[formControlName="${field}"]`);
        if (element) {
          element.classList.add('shake');
          setTimeout(() => element.classList.remove('shake'), 500);
        }
        control.markAsTouched({ onlySelf: true });
      }
    });
  }

goToNextStep() {
  if (this.valForm.controls['email'].invalid) {
    this.valForm.controls['email'].markAsTouched();
    this.toastr.warningToastr('Please enter valid Email');
    this.triggerValidationShake();
    return;
  }

  if (!this.OTP_email_verified) {
    this.toastr.warningToastr('Email Not Verified');
    return;
  }

  if (this.currentStep < this.steps.length - 1) {
    this.currentStep++;
  }
}



// goToNextStep() {
//   const branch = this.valForm.get('branch').value;
//   const regNo = this.valForm.get('reg_no').value;

//   if (this.valForm.valid && branch && regNo) {
//     this.currentStep++;
//   } else {
//     this.triggerValidationShake();
//     // this.focusFirstInvalidField();
//   }
// }

  ngAfterViewInit() {
    this.candidateNameInput.nativeElement.focus();
    if (this.otp0 && this.otp0.nativeElement) {
      this.otp0.nativeElement.focus();
    }
    else if (this.otpp0 && this.otpp0.nativeElement) {
      this.otpp0.nativeElement.focus();
    }
  }

  moveToNext(event: any, index: number) {
    const input = event.target.value;
    if (/^\d$/.test(input)) {
      this.otpInputs[index] = input;
      const nextInput = this.getOtpInputRef(index + 1);
      if (nextInput && nextInput.nativeElement) {
        nextInput.nativeElement.focus();
      }
    } else {
      this.otpInputs[index] = '';
    }
    const fullOtp = this.otpInputs.join('');
    this.OTP_Form.get('otp').setValue(fullOtp);
  }

  handleKeyDown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace') {
      if (this.otpInputs[index]) {
        this.otpInputs[index] = '';
      } else {
        const prevInput = this.getOtpInputRef(index - 1);
        if (prevInput && prevInput.nativeElement) {
          prevInput.nativeElement.focus();
        }
      }
      const fullOtp = this.otpInputs.join('');
      this.OTP_Form.get('otp').setValue(fullOtp);
    }
  }

  moveTooNext(event: any, index: number) {
    const input = event.target.value;
    if (/^\d$/.test(input)) {
      this.otpInput[index] = input;
      const nextInput = this.getOtpInputReff(index + 1);
      if (nextInput && nextInput.nativeElement) {
        nextInput.nativeElement.focus();
      }
    } else {
      this.otpInput[index] = '';
    }
    const fullOtp = this.otpInput.join('');
    this.OTP_email_Form.get('otpp').setValue(fullOtp);
  }

  handleKeyyDown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace') {
      if (this.otpInput[index]) {
        this.otpInput[index] = '';
      } else {

        const prevInput = this.getOtpInputReff(index - 1);
        if (prevInput && prevInput.nativeElement) {
          prevInput.nativeElement.focus();
        }
      }
      const fullOtp = this.otpInput.join('');
      this.OTP_email_Form.get('otpp').setValue(fullOtp);
    }
  }


    getOtpInputRef(index: number): ElementRef {
      switch (index) {
        case 0: return this.otp0;
        case 1: return this.otp1;
        case 2: return this.otp2;
        case 3: return this.otp3;
        default: return null;
      }
    }
    getOtpInputReff(index: number): ElementRef {
      switch (index) {
        case 0: return this.otpp0;
        case 1: return this.otpp1;
        case 2: return this.otpp2;
        case 3: return this.otpp3;
        default: return null;
      }
    }

  changeEmail() {
    this.OTP_email_popup.hide();
    setTimeout(() => {
      if (this.emailInput && this.emailInput.nativeElement) {
        this.emailInput.nativeElement.focus();
      }
    }, 300);
  }

  change() {
    this.OTP_popup.hide();
    setTimeout(() => {
      if (this.mobileInput && this.mobileInput.nativeElement) {
        this.mobileInput.nativeElement.focus();
      }
    }, 300);
  }
}